import { Flex, IconButton, Tooltip } from '@chakra-ui/react';
import { FaFolderTree, FaSitemap, FaTableList } from 'react-icons/fa6';

import { SkuViewMode } from './types';

const MODES: Array<{
  id: SkuViewMode;
  label: string;
  icon: JSX.Element;
}> = [
  { id: 'linear', label: 'Линейное представление', icon: <FaTableList /> },
  { id: 'tree', label: 'Иерархия категорий', icon: <FaSitemap /> },
  { id: 'catalog', label: 'Каталог групп', icon: <FaFolderTree /> },
];

export const SkuViewModeToolbar = ({
  mode,
  onChange,
}: {
  mode: SkuViewMode;
  onChange: (mode: SkuViewMode) => void;
}) => (
  <Flex gap={1}>
    {MODES.map((item) => (
      <Tooltip key={item.id} label={item.label}>
        <IconButton
          aria-label={item.id}
          icon={item.icon}
          size="sm"
          colorScheme={mode === item.id ? 'brand' : undefined}
          variant={mode === item.id ? 'solid' : 'ghost'}
          onClick={() => onChange(item.id)}
        />
      </Tooltip>
    ))}
  </Flex>
);
